import styled from 'styled-components';
import { Col, Row } from 'antd';

import BaseModal from 'global/Modal/BaseModal';
import { HeaderRow as BaseModalHeaderRow, Title } from 'global/Modal/BaseModal/styled';

export const Modal = styled(BaseModal)`
  & .ant-modal-body {
    padding: 18px 0 20px;
  }

  & ${Title} {
    font-size: 16px;
    line-height: 22px;
  }

  & ${BaseModalHeaderRow} {
    margin-bottom: 18px;
  }
`;

export const HeaderRow = styled(Row)`
  padding: 0 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  
  span {
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    width: 70%;
  }
`;

export const ContentRow = styled(Row)`
  padding: 20px;
`;

export const ContentCard = styled(Col)`
  width: 100%;
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid #ededed;

  .share-preview {
    width: 100% !important;
  }
`;

export const CardHeader = styled.div`
  width: 100%;
  padding: 16px;
`;

export const CardLists = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 16px;
  border-top: 1px solid #ededed;

  max-height: 250px;
  overflow-y: auto;
  overflow-x: hidden;

  & > .ant-row {
    margin: 8px 0;
  }
`;

export const FooterCol = styled(Col)`
  border-top: 1px solid #ededed;
  padding: 12px 20px 0;
`;
